import styled from "styled-components/macro";
import { Link as ReactLink } from "react-router-dom";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const HeaderIcon = styled.img<{ width: string }>`
  width: ${({ width }) => width};
  margin: auto;
  height: inherit;
`;

export const HeaderLockupImg = styled.img`
  display: block;
  height: 30px;
  width: auto;
`;

export const MobileMenuToggleIcon = styled(HeaderIcon)`
  filter: brightness(0) invert(1);
  cursor: pointer;
`;

export const HeaderContainer = styled.div`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.11);
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 89px;
  background: ${({ theme }) => theme.headerBackground};

  @media only screen and (max-width: 1200px) {
    height: 63px;
  }
`;

export const HeaderIconsLinksContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 50px 0 60px;

  @media only screen and (max-width: 1200px) {
    padding: 0 24px;
  }

  > a {
    display: flex;
    text-decoration: none;
  }
`;

export const HeaderIconsContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  @media only screen and (max-width: 1200px) {
    img {
      height: 20px;
    }
  }
`;

export const HeaderLinksContainer = styled.div<{ onlyLogin: boolean }>`
  display: flex;
  align-items: center;
  white-space: nowrap;

  a {
    text-decoration: none;
  }

  a:hover p {
    color: ${({ theme }) => theme.tealAccent} !important;
  }
`;

export const HeaderProfileWarning = styled(ReactLink)<{
  deviceType: DeviceType;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;

  p {
    padding: 20px 0px 20px 20px;
  }

  svg {
    align-self: center;
    margin-left: -14px;
    margin-top: -4px;
  }

  path {
    fill: ${({ deviceType, theme }) =>
      deviceType === "mobile" ? theme.white : theme.redDark};
  }
`;

export const HeaderIconContainerMobile = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: center;
  height: 100%;
  padding-left: 24px;
`;

export const HeaderIconContainerMobileGrid = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: ${({ deviceType }) =>
    deviceType === "mobile" ? "15px" : "30px"};
`;

export const HeaderIconContainerBabyPeekUnlockContainer = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.headerBackground};
  background: #ffe88d;
  border-radius: 4px;
  margin-left: 8px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderAccordionWrapper = styled.div<{
  isActive?: boolean;
  deviceType: DeviceType;
}>`
  margin: ${({ deviceType }) => (deviceType !== "desktop" ? "-4px" : "0px")};
  width: ${({ deviceType }) =>
    deviceType !== "desktop" ? undefined : "180px"};
  .MuiAccordion-root {
    background: transparent;
    box-shadow: none;

    &::before {
      display: none;
    }
  }
  .MuiTypography-root {
    padding: 0px 0px;
  }

  .MuiAccordionSummary-root {
    margin-left: 8px;
  }
  .Mui-expanded {
    background: transparent;
    min-height: 20px !important;
  }
  .MuiCollapse-root {
    z-index: 10;
    position: ${({ deviceType }) =>
      deviceType === "desktop" ? "fixed" : undefined};
    background: ${({ deviceType, theme }) =>
      deviceType === "desktop" ? theme.headerBackground : undefined};
  }
  .MuiSvgIcon-root {
    width: ${({ deviceType }) => (deviceType !== "desktop" ? "1.5em" : "1em")};
    height: ${({ deviceType }) => (deviceType !== "desktop" ? "1.5em" : "1em")};
    fill: ${({ isActive, theme }) =>
      isActive ? theme.tealAccent : theme.white};
  }
  ${({ deviceType, theme }) =>
    deviceType === "desktop" &&
    `
    .MuiAccordionSummary-root:hover p {
      color: ${theme.tealAccent} !important;
    }
    .MuiAccordionSummary-root:hover .MuiSvgIcon-root {
      fill: ${theme.tealAccent};
    }
  `}
`;

export const HeaderAccordionGrid = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  grid-gap: 20px;
  margin-left: 20px;
  margin-top: -5px;
`;
